import React, { useContext } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers';
import { Button, TextField, Grid } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { I18nContext } from 'translations';
import schema from './schema';

export default function UsersTableFilters({ submit }) {
  const { translate } = useContext(I18nContext);
  const { handleSubmit, register, errors } = useForm({
    resolver: yupResolver(schema),
  });

  return (
    <form onSubmit={handleSubmit(submit)} autoComplete="off" noValidate>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={4}>
          <TextField
            name="name"
            label={translate('name')}
            type="text"
            inputRef={register}
            variant="outlined"
            size="small"
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            name="email"
            error={!!errors.email}
            label={translate('email')}
            helperText={errors.email && translate(errors.email.message)}
            type="email"
            inputRef={register}
            variant="outlined"
            size="small"
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm="auto">
          <Button
            type="submit"
            color="primary"
            variant="contained"
            startIcon={<SearchIcon />}
            style={{ borderRadius: 12, textTransform: 'none', padding: '7px 20px', fontSize: '0.85rem' }}
          >
            {translate('search')}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}
